function Folder(props) {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_67_1139)">
        <path
          d="M18.639 18.281H3.38422C3.21615 18.2806 3.0551 18.2136 2.93626 18.0947C2.81742 17.9759 2.75045 17.8149 2.75 17.6468V7.28101H18.5625C18.7448 7.28101 18.9197 7.35344 19.0486 7.48237C19.1776 7.6113 19.25 7.78617 19.25 7.96851V17.67C19.25 17.832 19.1856 17.9875 19.071 18.102C18.9564 18.2166 18.801 18.281 18.639 18.281Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.75 7.28101V5.21851C2.75 5.03617 2.82243 4.8613 2.95136 4.73237C3.0803 4.60344 3.25516 4.53101 3.4375 4.53101H7.96555C8.14764 4.53109 8.32226 4.60341 8.45109 4.7321L11 7.28101"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_67_1139">
          <rect width="22" height="22" fill="white" transform="translate(0 0.406006)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Folder;
